import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
} from "react";
import { useNavigate, useParams } from "react-router-dom";
import PLAN_URL from "../../../utils/PLAN_URL";
import axios from "axios";
import {
  Alert,
  Button,
  CircularProgress,
  Snackbar,
  Typography,
  Box,
  Tooltip,
  IconButton,
  TextField,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useGetTableData2 } from "../Plan/tableHooks";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { localizationTextObjectForInformation } from "../../../utils/constants";
import Box3d50 from "../../Nucleo-Icons/box-3d-50";
import goToHelpLink from "../../../utils/goToHelpLink";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import styled from "styled-components";
import Link3 from "../Nucleo-Icons/link-3";
import ScrollText from "../Nucleo-Icons/scroll-text";
import LinkBroken from "../Nucleo-Icons/link-broken";
import Pen01 from "../../Nucleo-Icons/pen-01";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

const ContainerViewer = styled.div`
  height: calc(100vh - 65px);
  display: flex;
  box-sizing: border-box;
  background-color: #fff;
  justify-content: center;
`;
const Section = styled.div`
  // flex: ${(props) => props.$flex || 1};
  width: 550px;
  position: relative;
  height: 100%;
`;

const SectionFlex2 = styled.div`
  // flex: ${(props) => props.$flex || 1};
  width: 1100px;
  position: relative;
  height: 100%;
`;
const SectionContent = styled.div`
  height: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  border: 1px solid rgb(var(--mui-mainColorChannels-light) / 0.12);
  margin-top: 1.5rem;
`;

const IconContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

// BOM 관리.
function BomManagement() {
  const { group_code, project_code } = useParams();
  const [loading, setLoading] = useState(false);
  const [clickedItemId, setClickedItemId] = useState(null);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const openSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };
  const [currentBom, setCurrentBom] = useState([]);
  const navigation = useNavigate();
  // Row 선택 관련 state
  const [selectedRowIds, setSelectedRowIds] = useState({});
  const [lastClickedIndex, setLastClickedIndex] = useState(null);
  const tableInstanceRef = useRef(null);

  const { data } = useGetTableData2(
    updateStatus,
    `/api/item/getAllItems?group_code=${group_code}&project_code=${project_code}`
  );

  const { materialData } = useGetTableData2(
    updateStatus,
    `/api/material/bring?group_code=${group_code}&project_code=${project_code}`,
    "materialData"
  );

  const { allBomData } = useGetTableData2(
    updateStatus,
    `/api/bom/getAll?group_code=${group_code}&project_code=${project_code}`,
    "allBomData"
  );

  useEffect(() => {
    if (clickedItemId) {
      const targetBomData = allBomData.filter(
        (item) => item.item_id === clickedItemId
      );
      const calculateCurrentBom = materialData.map((material) => {
        const matchingBomItem = targetBomData.find(
          (bomItem) =>
            bomItem.item_id === clickedItemId &&
            bomItem.material_id === material.material_id
        );
        if (matchingBomItem) {
          return {
            ...material,
            isConnected: true,
            quantity: matchingBomItem.quantity || "0",
            qty_unit: matchingBomItem.qty_unit || "EA",
          };
        } else {
          return {
            ...material,
            isConnected: false,
            quantity: "연결 후 설정해주세요.",
            qty_unit: "연결 후 설정해주세요.",
          };
        }
      });
      const sortedBom = [...calculateCurrentBom].sort((a, b) => {
        if (a.isConnected && !b.isConnected) return -1;
        if (!a.isConnected && b.isConnected) return 1;
        return 0;
      });
      setCurrentBom(sortedBom);
      setSelectedRowIds({});
      setLastClickedIndex(null);
    } else {
      setCurrentBom([]);
    }
  }, [clickedItemId, materialData, allBomData, updateStatus]);
  const handleRowClick = useCallback(
    ({ event, row }) => {
      const index = row.index;
      const rowId = row.id;
      const tableInstance = tableInstanceRef.current;
      if (!tableInstance) return;
      const allRows = tableInstance.getRowModel().rows;
      if (event.shiftKey && lastClickedIndex !== null) {
        const start = Math.min(lastClickedIndex, index);
        const end = Math.max(lastClickedIndex, index);
        const newSelected = {};
        for (let i = start; i <= end; i++) {
          newSelected[allRows[i].id] = true;
        }
        setSelectedRowIds(newSelected);
      } else if (event.ctrlKey || event.metaKey) {
        setSelectedRowIds((prev) => ({
          ...prev,
          [rowId]: !prev[rowId],
        }));
        setLastClickedIndex(index);
      } else {
        setSelectedRowIds({ [rowId]: true });
        setLastClickedIndex(index);
      }
    },
    [lastClickedIndex]
  );
  const handleConnectSelected = async () => {
    if (!clickedItemId) {
      openSnackbar("아이템을 먼저 선택해주세요.", "error");
      return;
    }
    try {
      const selectedMaterials = Object.keys(selectedRowIds).map(
        (id) => currentBom[parseInt(id)]
      );
      const res = await axios.post(PLAN_URL + "/api/bom/create", {
        group_code,
        project_code,
        item_id: clickedItemId,
        data: selectedMaterials,
      });
      if (res.status === 200) {
        openSnackbar(
          `${selectedMaterials.length}개 자재가 연결되었습니다.`,
          "success"
        );
      }
    } catch (e) {
      console.log(e);
      openSnackbar(e.data.message, "error");
    } finally {
      setSelectedRowIds({});
      setUpdateStatus((prev) => !prev);
    }
  };
  const handleDisconnectSelected = async () => {
    if (!clickedItemId) {
      openSnackbar("아이템을 먼저 선택해주세요.", "error");
      return;
    }
    try {
      const selectedMaterials = Object.keys(selectedRowIds).map(
        (id) => currentBom[parseInt(id)]
      );
      const payload = {
        group_code,
        project_code,
        item_id: clickedItemId,
        ids: selectedMaterials.map((i) => i.material_id),
      };
      const res = await axios.delete(PLAN_URL + "/api/bom/delete", {
        data: payload,
      });
      if (res.status === 200) {
        openSnackbar(
          `${selectedMaterials.length}개 자재 연결이 해제되었습니다.`,
          "info"
        );
      }
    } catch (e) {
      console.log(e);
      openSnackbar("error", "error");
    } finally {
      setUpdateStatus((prev) => !prev);
      setSelectedRowIds({});
    }
  };
  const handleUpdateBom = async (values, row) => {
    if (!clickedItemId) {
      openSnackbar("아이템을 먼저 선택해주세요.", "error");
      return;
    }
    const qty_unit = values.qty_unit;
    const quantity = values.quantity;
    if (!qty_unit || typeof qty_unit !== "string") {
      openSnackbar("단위는 문자열 형식이어야 합니다.", "error");
      return;
    }
    const numberRegex = /^-?\d+(\.\d+)?$/;
    if (!numberRegex.test(String(quantity))) {
      openSnackbar("수량은 숫자만 입력 가능합니다.", "error");
      return;
    }
    const parsedQuantity = parseFloat(quantity);
    if (isNaN(parsedQuantity)) {
      openSnackbar("수량은 유효한 숫자 형식이어야 합니다.", "error");
      return;
    }
    try {
      const payload = {
        group_code,
        project_code,
        item_id: clickedItemId,
        material_id: row.original.material_id,
        quantity: parsedQuantity,
        qty_unit: qty_unit,
      };
      const res = await axios.put(PLAN_URL + "/api/bom/update", payload);
      if (res.status === 200) {
        openSnackbar("BOM 정보가 업데이트되었습니다.", "success");
        setUpdateStatus((prev) => !prev);
      }
    } catch (e) {
      console.log(e);
      openSnackbar("업데이트 중 오류가 발생했습니다.", "error");
    }
  };
  const columns = [
    {
      accessorKey: "item_id",
      header: "Item ID",
      size: 80,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      muiTableFooterCellProps: { align: "center" },
      enableEditing: false,
    },
    {
      accessorKey: "item_name",
      header: "Item이름",
      size: 80,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      muiTableFooterCellProps: { align: "center" },
    },
    {
      accessorKey: "item_code",
      header: "Item코드",
      size: 80,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      muiTableFooterCellProps: { align: "center" },
    },
    // {
    //   accessorKey: "pce",
    //   header: "PCE",
    //   size: 80,
    //   muiTableHeadCellProps: { align: "center" },
    //   muiTableBodyCellProps: { align: "center" },
    //   muiTableFooterCellProps: { align: "center" },
    // },
    // {
    //   accessorKey: "lot_size",
    //   header: "LOT",
    //   size: 80,
    //   muiTableHeadCellProps: { align: "center" },
    //   muiTableBodyCellProps: { align: "center" },
    //   muiTableFooterCellProps: { align: "center" },
    // },
    {
      accessorKey: "safety_stock",
      header: "안전재고",
      size: 80,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      muiTableFooterCellProps: { align: "center" },
    },
    {
      accessorKey: "proc_qty",
      header: "총 공정 수",
      size: 80,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      muiTableFooterCellProps: { align: "center" },
      enableEditing: false,
    },
    {
      accessorKey: "proc_time",
      header: "공정 시간 합계",
      size: 80,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      muiTableFooterCellProps: { align: "center" },
      Cell: ({ row }) => {
        const minutes = row.original.proc_time / 60;
        const isInteger = minutes % 1 === 0;
        return `${isInteger ? minutes : minutes.toFixed(1)}분`;
      },
      enableEditing: false,
    },
  ];
  const columns2 = [
    {
      accessorKey: "isConnected",
      header: "",
      size: 10,
      Cell: ({ row }) => {
        return row.original.isConnected ? (
          <Tooltip title="Connected!">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <LinkBroken />
            </Box>
          </Tooltip>
        ) : (
          ""
        );
      },
      enableEditing: false,
    },
    {
      accessorKey: "material_name",
      header: "material_name",
      //  size: 120,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      muiTableFooterCellProps: { align: "center" },
      enableEditing: false,
    },
    {
      accessorKey: "quantity",
      header: "quantity",
      //  size: 80,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      muiTableFooterCellProps: { align: "center" },
      enableEditing: true,
    },
    {
      accessorKey: "qty_unit",
      header: "qty_unit",
      //   size: 80,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      muiTableFooterCellProps: { align: "center" },
      enableEditing: true,
    },
    {
      accessorKey: "material_description",
      header: "material_description",
      //    size: 80,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      muiTableFooterCellProps: { align: "center" },
      enableEditing: false,
    },
  ];
  const closeSnackbar = () => setSnackbar({ ...snackbar, open: false });
  const table = useMaterialReactTable({
    data: data ?? [],
    columns,
    enableColumnFilters: false,
    enableColumnFilterModes: false,
    enableColumnOrdering: false,
    enableSorting: false,
    enableStickyHeader: true,
    enableColumnActions: false,
    enableEditing: false,
    createDisplayMode: "modal",
    editDisplayMode: "row",
    localization: localizationTextObjectForInformation,
    initialState: {
      columnVisibility: {
        item_id: false,
      },
    },
    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        cursor: "pointer",
        background: () => {
          return clickedItemId === Number(row.original.item_id)
            ? "#dee2e6 !important"
            : "#F8F7FA !important";
        },
      },
      onClick: (e) => {
        setClickedItemId(row.original.item_id);
      },
    }),
    muiTablePaperProps: {
      sx: {
        width: "100%",
        height: "100%",
        background: "#fff",
        "& .css-qc99f7": {
          position: "absolute !important",
          bottom: "30px",
          borderBottom: "1px solid #d6d8df",
        },
      },
    },
    muiTableBodyCellProps: {
      sx: {
        color: "black",
        fontWeight: "500",
        fontSize: "14px",
      },
    },
    muiTableFooterCellProps: {
      sx: {
        position: "absolute !important",
        bottom: 0,
      },
    },
    muiTableHeadProps: {
      sx: {
        "& tr": {
          fontWeight: "700",
          borderRadius: "14px",
          background: "#f3f6f9",
          color: "#464e5f",
          "& th": {
            fontWeight: "500 !important",
            color: "black",
            padding: "0.5rem",
            fontSize: "15px",
          },
        },
      },
    },
    paginationDisplayMode: "pages",
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          height: "40px",
          width: "150px",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          fontSize: "22px",
          background: "#F8F7FA",
          fontWeight: "700",
          gap: "1rem",
          paddingLeft: "0.53rem",
        }}
      >
        <Box3d50 />
        Item{" "}
        <Tooltip
          title="이동"
          sx={{ cursor: "pointer" }}
          onClick={() =>
            goToHelpLink(
              "http://esehelp.cafe24.com/planner#h-8-1-%EC%95%84%EC%9D%B4%ED%85%9C-%EC%98%81%EC%97%AD"
            )
          }
        >
          <HelpOutlineIcon />
        </Tooltip>
      </Box>
    ),
    renderToolbarInternalActions: ({ table }) => (
      <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}></div>
    ),
    positionActionsColumn: "last",
    muiBottomToolbarProps: {
      sx: {
        position: "absolute !important",
        bottom: "42px",
        left: "50%",
        width: "inherit",
        transform: "translate(-50%, -50%)",
      },
    },
  });
  const table2 = useMaterialReactTable({
    data: currentBom ?? [],
    columns: columns2,
    enableColumnFilters: false,
    enableColumnFilterModes: false,
    enableColumnOrdering: false,
    enableSorting: false,
    enableStickyHeader: true,
    enableColumnActions: false,
    enableEditing: true,
    createDisplayMode: "modal",
    editDisplayMode: "row",
    localization: localizationTextObjectForInformation,
    enableRowSelectionToolbar: false,
    positionToolbarAlertBanner: "none",
    muiToolbarAlertBannerProps: {
      sx: { display: "none" },
    },
    onEditingRowCancel: () => {
      setSelectedRowIds({});
    },
    onEditingRowSave: ({ row, values, exitEditingMode }) => {
      if (!row.original.isConnected) {
        openSnackbar("먼저 자재를 아이템에 연결해야 합니다.", "warning");
        exitEditingMode();
        return;
      }

      handleUpdateBom(values, row)
        .then(() => {
          exitEditingMode();
        })
        .catch(() => {
          openSnackbar("업데이트 중 오류가 발생했습니다.", "error");
          exitEditingMode();
        });
    },
    initialState: {
      columnVisibility: {
        item_id: false,
      },
    },
    state: {
      rowSelection: selectedRowIds,
    },
    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        cursor: "pointer",
        background: () => {
          if (selectedRowIds[row.id]) {
            return "#e3f2fd !important";
          }
          return row.original.isConnected
            ? "#98ed80 !important"
            : "#F8F7FA !important";
        },
      },
      onClick: (event) => {
        handleRowClick({ event, row });
      },
    }),
    muiTablePaperProps: {
      sx: {
        width: "100%",
        height: "100%",
        background: "#fff",
        "& .css-qc99f7": {
          position: "absolute !important",
          bottom: "30px",
          borderBottom: "1px solid #d6d8df",
        },
      },
    },
    muiTableBodyCellProps: {
      sx: {
        color: "black",
        fontWeight: "500",
        fontSize: "14px",
      },
    },
    muiTableFooterCellProps: {
      sx: {
        position: "absolute !important",
        bottom: 0,
      },
    },
    muiTableHeadProps: {
      sx: {
        "& tr": {
          fontWeight: "700",
          borderRadius: "14px",
          background: "#f3f6f9",
          color: "#464e5f",
          "& th": {
            fontWeight: "500 !important",
            color: "black",
            padding: "0.5rem",
            fontSize: "15px",
          },
        },
      },
    },
    paginationDisplayMode: "pages",
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          height: "40px",
          width: "350px",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          fontSize: "22px",
          background: "#F8F7FA",
          fontWeight: "700",
          gap: "1rem",
          paddingLeft: "0.53rem",
        }}
      >
        <ScrollText />
        MATERIAL{" "}
        <Tooltip
          title="이동"
          sx={{ cursor: "pointer" }}
          onClick={() =>
            goToHelpLink(
              "http://esehelp.cafe24.com/planner#h-8-1-%EC%95%84%EC%9D%B4%ED%85%9C-%EC%98%81%EC%97%AD"
            )
          }
        >
          <HelpOutlineIcon />
        </Tooltip>
      </Box>
    ),
    renderToolbarInternalActions: ({ table }) => {
      const selectedRows = Object.keys(selectedRowIds).length;
      const hasSelection = selectedRows > 0;
      return (
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <TextField
            placeholder="검색어를 입력하세요"
            size="small"
            // value={searchText}
            // onChange={onChangeSearchValue}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <Button
            variant="contained"
            color="success"
            startIcon={<CheckIcon />}
            onClick={handleConnectSelected}
            disabled={!hasSelection || !clickedItemId}
            size="small"
          >
            선택 연결
          </Button>
          <Button
            variant="contained"
            color="error"
            startIcon={<CloseIcon />}
            onClick={handleDisconnectSelected}
            disabled={!hasSelection || !clickedItemId}
            size="small"
          >
            선택 연결해제
          </Button>
          <Button
            variant="contanied"
            color="secondary"
            onClick={() => {
              navigation(
                `/plan/${group_code}/${project_code}/standard/material`
              );
            }}
            size="small"
          >
            자재 등록
          </Button>
        </div>
      );
    },
    positionActionsColumn: "last",
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: "flex", width: "20px" }}>
        <Tooltip title="Edit">
          <IconButton
            onClick={() => {
              if (!row.original.isConnected) {
                openSnackbar(
                  "먼저 자재를 아이템에 연결해야 합니다.",
                  "warning"
                );
                return;
              }
              table.setEditingRow(row);
            }}
          >
            <Pen01 />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    muiBottomToolbarProps: {
      sx: {
        position: "absolute !important",
        bottom: "42px",
        left: "50%",
        width: "inherit",
        transform: "translate(-50%, -50%)",
      },
    },
  });
  useEffect(() => {
    tableInstanceRef.current = table2;
  }, [table2]);
  return (
    <>
      <ContainerViewer>
        <div
          style={{
            width: "95%",
            display: "flex",
            justifyContent: "center",
            gap: "0.5rem",
            height: "100%",
            alignItems: "flex-start",
          }}
        >
          <Section>
            <SectionContent>
              <MaterialReactTable
                muiTableBodyProps={{
                  sx: { overflow: "visible" },
                }}
                table={table}
              />
            </SectionContent>
          </Section>
          <IconContainer>
            <Link3 />
          </IconContainer>
          <SectionFlex2>
            <SectionContent>
              <MaterialReactTable
                muiTableBodyProps={{
                  sx: { overflow: "visible" },
                }}
                table={table2}
              />
            </SectionContent>
          </SectionFlex2>
        </div>
      </ContainerViewer>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={closeSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default BomManagement;
